import * as ActionTypes from "../constants/actiontypes/user";
import * as AuthActionTypes from "../constants/actiontypes/auth";
import * as ActionTypesFacilita from "../constants/actiontypes/facilita/deathDeclaration";
import User from "../constants/models/user";
import Address from "../constants/models/address";
import Referent from "../constants/models/referent";
import Service from "../constants/models/service";
import DocumentFile from "../constants/models/documentFile";
import CardPaymentMethod from "../constants/models/cardPaymentMethod";
import SepaPaymentMethod from "../constants/models/sepaPaymentMethod";
import * as Loadings from "../constants/loadings/user";
import * as LoadingsFacilita from "../constants/loadings/facilita/deathDeclaration";
import Invoice from "../constants/models/invoice";
import * as R from "ramda";
import * as Text from "../constants/toasterText/user";
import { toast } from "react-toastify";
import BackofficeUser from "../constants/models/backofficeUser";

const toastConf = { position: toast.POSITION.TOP_RIGHT, autoClose: 3000 };

const UserReducer = (
	state = {
		isLoading: [],
		user: undefined,
		address: undefined,
		referents: [],
		services: [],
		documents: [],
		serviceDatas: [],
		message: "",
		profilePicture: undefined,
		isDeletingReferent: false,
		stripeClientSecret: undefined,
		signupStep4Success: false,
		invoices: [],
		partnerCustomization: {
			isLoaded: false,
			logoBase64Encoded: undefined,
			color: undefined,
		},
		events: [],
	},
	action
) => {
	switch (action.type) {
		case ActionTypes.RESET_USER_STATE:
			state.isLoading = [];
			state.user = undefined;
			state.address = undefined;
			state.referents = [];
			state.services = [];
			state.serviceDatas = [];
			state.isDeletingReferent = false;
			state.partnerCustomization = {
				isLoaded: false,
				logoBase64Encoded: undefined,
				color: undefined,
			};
			state.events = [];
			return { ...state };
		case ActionTypes.FETCH_USER_REQUEST:
			if (!state.isLoading.includes(Loadings.FETCH_USER)) {
				state.isLoading.push(Loadings.FETCH_USER);
			}
			return { ...state };
		case ActionTypes.FETCH_USER_SUCCESS:
			state.isLoading = state.isLoading.filter((s) => s !== Loadings.FETCH_USER);
			if (Array.isArray(action.data)) {
				state.user = new User(action.data[0]);
			} else {
				state.user = new User(action.data);
			}
			return { ...state };
		case ActionTypes.FETCH_USER_FAILURE:
			state.isLoading = state.isLoading.filter((s) => s !== Loadings.FETCH_USER);
			return { ...state };

		case ActionTypes.UPDATE_USER_REQUEST:
			if (!state.isLoading.includes(Loadings.UPDATE_USER)) {
				state.isLoading = state.isLoading.concat(Loadings.UPDATE_USER);
			}
			return { ...state };
		case ActionTypes.UPDATE_USER_SUCCESS:
			let professions = [];
			if (!R.isEmpty(action.user.professionalSituation) && action.user.professionalSituation !== "0") {
				let allProfs = action.user.professionalSituation.split(",");
				if (Array.isArray(allProfs)) {
					allProfs.forEach((p) => {
						professions.push(p.trim());
					});
				} else {
					professions.push(allProfs);
				}
			}
			state.user = {
				...state.user,
				birthDate: action.user.birthDate,
				birthPlace: action.user.birthPlace,
				civilStatus: action.user.civilStatus,
				country: action.user.country,
				departmentNumber: action.user.departmentNumber,
				firstName: action.user.firstName,
				gender: action.user.gender,
				hasChildren: action.user.hasChildren,
				hasPets: action.user.hasPets,
				lastName: action.user.lastName,
				processNumber: action.user.processNumber,
				professionalSituation: professions,
			};
			state.isLoading = state.isLoading.filter((l) => l !== Loadings.UPDATE_USER);
			toast.success(Text.dataUpdatedSuccess, toastConf);
			return { ...state };
		case ActionTypes.UPDATE_USER_FAILURE:
			state.isLoading = state.isLoading.filter((l) => l !== Loadings.UPDATE_USER);
			toast.error(Text.dataUpdateFailed, toastConf);
			return { ...state };
		case ActionTypes.FETCH_USER_ADDRESS_SUCCESS:
			if (action.data.length > 0 && action.data[0] !== undefined) {
				state.address = new Address(action.data[0]);
			}
			return { ...state };
		case ActionTypes.UPDATE_USER_ADDRESS_SUCCESS:
			state.address = new Address(action.address);
			return { ...state };

		case ActionTypes.FETCH_REPRESENTATIVES_REQUEST:
			if (!state.isLoading.includes(Loadings.FETCH_REPRESENTATIVES)) {
				state.isLoading.push(Loadings.FETCH_REPRESENTATIVES);
			}
			return { ...state };
		case ActionTypes.FETCH_REPRESENTATIVES_SUCCESS:
			state.referents = action.data.filter((r) => r.userId === state.user.id).map((r) => new Referent(r));
			state.isLoading = state.isLoading.filter((l) => l !== Loadings.FETCH_REPRESENTATIVES);
			return { ...state };
		case ActionTypes.UPDATE_REPRESENTATIVE_SUCCESS:
			let referentIndex = state.referents.findIndex((r) => r.id === action.referent.id);
			if (referentIndex !== -1) {
				state.referents[referentIndex] = new Referent(action.referent);
			}
			return { ...state };
		case ActionTypes.FETCH_REPRESENTATIVES_ADDRESS_REQUEST:
			if (!state.isLoading.includes(`${Loadings.FETCH_REPRESENTATIVES_ADDRESS}_${action.referent.id}`)) {
				state.isLoading.push(`${Loadings.FETCH_REPRESENTATIVES_ADDRESS}_${action.referent.id}`);
			}
			return { ...state };
		case ActionTypes.FETCH_REPRESENTATIVES_ADDRESS_SUCCESS:
			state.isLoading = state.isLoading.filter((l) => l !== `${Loadings.FETCH_REPRESENTATIVES_ADDRESS}_${action.referent.id}`);
			let referentId = state.referents.findIndex((r) => r.id === action.referent.id);
			if (referentId !== -1) {
				state.referents[referentId].address = new Address(action.data[0]);
			}
			return { ...state };
		case ActionTypes.FETCH_REPRESENTATIVES_ADDRESS_FAILURE:
			state.isLoading = state.isLoading.filter((l) => l !== `${Loadings.FETCH_REPRESENTATIVES_ADDRESS}_${action.referent.id}`);
			return { ...state };
		case ActionTypes.ADD_REPRESENTATIVE_ADDRESS_SUCCESS:
			let referentIndex3 = state.referents.findIndex((r) => r.id === action.referentId);
			if (referentIndex3 !== -1) {
				state.referents[referentIndex3].address = new Address(action.data);
			}
			return { ...state };
		case ActionTypes.UPDATE_REPRESENTATIVE_ADDRESS_SUCCESS:
			let referentIndex2 = state.referents.findIndex((r) => r.id === action.referentId);
			if (referentIndex2 !== -1) {
				state.referents[referentIndex2].address = new Address(action.address);
			}
			return { ...state };
		case ActionTypes.ADD_REPRESENTATIVE_SUCCESS:
			let newReferent = new Referent(action.data);
			if (action.tmpRef !== undefined) {
				newReferent.tmpRef = action.tmpRef;
			}
			state.referents.push(newReferent);

			return { ...state };

		case ActionTypes.DELETE_REPRESENTATIVE_REQUEST:
			state.isDeletingReferent = true;
			return { ...state };
		case ActionTypes.DELETE_REPRESENTATIVE_SUCCESS:
			state.isDeletingReferent = false;
			state.referents = state.referents.filter((r) => r.id !== action.referent.id);
			return { ...state };
		case ActionTypes.DELETE_REPRESENTATIVE_FAILURE:
			state.isDeletingReferent = false;
			return { ...state };

		case ActionTypes.FETCH_USER_SERVICES_REQUEST:
			if (!state.isLoading.includes(`${Loadings.FETCH_SERVICES}`)) {
				state.isLoading.push(`${Loadings.FETCH_SERVICES}`);
			}
			return { ...state };
		case ActionTypes.FETCH_USER_SERVICES_SUCCESS:
			state.isLoading = state.isLoading.filter((l) => l !== Loadings.FETCH_SERVICES);
			if (action.data.length > 0) {
				action.data.forEach((s) => {
					if (state.services.findIndex((sv) => sv.id === s.id) === -1) {
						state.services.push(new Service(s));
					}
				});
			}
			return { ...state };
		case ActionTypes.ADD_USER_SERVICE_SUCCESS:
			if (state.services.findIndex((s) => s.id === action.data.id) === -1) {
				state.services.push(new Service(action.data));
			}
			return { ...state };

		case ActionTypes.ADD_SERVICES_BATCH_REQUEST:
			state.signupStep4Success = false;
			if (!state.isLoading.includes(Loadings.UPDATING_SERVICES)) {
				state.isLoading = state.isLoading.concat(Loadings.UPDATING_SERVICES);
			}
			return { ...state };
		case ActionTypes.ADD_SERVICES_BATCH_SUCCESS:
			state.isLoading = state.isLoading.filter((l) => l !== Loadings.UPDATING_SERVICES);
			state.signupStep4Success = true;

			state.services = action.data.map((s) => new Service(s));

			return { ...state };
		case ActionTypes.ADD_SERVICES_BATCH_FAILURE:
			state.isLoading = state.isLoading.filter((l) => l !== Loadings.UPDATING_SERVICES);
			return { ...state };

		case ActionTypes.DELETE_USER_SERVICE_SUCCESS:
			state.services = state.services.filter((s) => s.id !== action.service.id);
			return { ...state };

		case ActionTypes.UPLOAD_DOCUMENT_REQUEST:
			if (!state.isLoading.includes(`${Loadings.UPLOADING_DOCUMENT}_${action.fileType}_${action.documentName}`)) {
				state.isLoading.push(`${Loadings.UPLOADING_DOCUMENT}_${action.fileType}_${action.documentName}`);
			}
			return { ...state };
		case ActionTypes.UPLOAD_DOCUMENT_SUCCESS:
			state.isLoading = state.isLoading.filter((l) => l !== `${Loadings.UPLOADING_DOCUMENT}_${action.file.fileType}_${action.file.fileName}`);
			state.documents.push(new DocumentFile({ fileName: action.file.fileName, fileType: action.file.fileType, description: action.file.description }));
			return { ...state };
		case ActionTypes.UPLOAD_DOCUMENT_FAILURE:
			state.isLoading = state.isLoading.filter((l) => l !== `${Loadings.UPLOADING_DOCUMENT}_${action.fileType}_${action.documentName}`);
			return { ...state };
		case ActionTypes.FETCH_DOCUMENTS_SUCCESS:
			if (action.data !== undefined && action.data.length > 0) {
				state.documents = action.data.map((d) => new DocumentFile(d));
			}
			return { ...state };

		case ActionTypes.EDIT_DOCUMENT_SUCCESS:
			state.documents = state.documents.map((document) => {
				if (document.fileName === action.file.fileName && document.fileType === action.file.fileType) {
					return new DocumentFile({ fileName: action.file.fileName, fileType: action.file.fileType, description: action.file.description });
				}
				return document;
			});
			return { ...state };

		case ActionTypes.DELETE_DOCUMENT_REQUEST:
			if (!state.isLoading.includes(`${Loadings.DELETING_DOCUMENT}_${action.fileType}`)) {
				state.isLoading.push(`${Loadings.DELETING_DOCUMENT}_${action.fileType}`);
			}
			return { ...state };
		case ActionTypes.DELETE_DOCUMENT_SUCCESS:
			state.documents = state.documents.filter((d) => d.fileName !== action.fileType);
			state.isLoading = state.isLoading.filter((l) => l !== `${Loadings.DELETING_DOCUMENT}_${action.fileType}`);
			return { ...state };
		case ActionTypes.DELETE_DOCUMENT_FAILURE:
			state.isLoading = state.isLoading.filter((l) => l !== `${Loadings.DELETING_DOCUMENT}_${action.fileType}`);
			return { ...state };

		case ActionTypes.UPDATE_MESSAGE_REQUEST:
			state.message = undefined;
			return { ...state };
		case ActionTypes.UPDATE_MESSAGE_SUCCESS:
			state.message = action.message;
			toast.success(Text.updateMessageSuccess, toastConf);
			return { ...state };
		case ActionTypes.UPDATE_MESSAGE_FAILURE:
			state.message = "";
			toast.error(Text.updateMessageError, toastConf);
			return { ...state };

		case ActionTypes.FETCH_MESSAGE_SUCCESS:
			state.message = action.data;
			return { ...state };

		case ActionTypes.GET_PROFILEPIC_SUCCESS:
			state.profilePicture = action.data;
			return { ...state };
		case ActionTypes.DELETE_PROFILEPIC_SUCCESS:
			state.profilePicture = undefined;
			return { ...state };
		case ActionTypes.UPLOAD_PROFILEPIC_SUCCESS:
			state.profilePicture = action.data;
			return { ...state };

		case ActionTypes.UPDATE_ONBOARDINGSTEP_SUCCESS:
			state.user.onBoardingStep = action.step;
			return { ...state };

		case ActionTypes.SET_COMPLETE_SUCCESS:
			state.user.setupCompletedDate = new Date();
			window.location = `/anticipa/dashboard`;
			return { ...state };

		case ActionTypes.ADD_PAYMENTMETHOD_SUCCESS:
			for (let i = 0; i < state.user.paymentMethods.length; i++) {
				state.user.paymentMethods[i].isDefault = false;
			}
			if (action.data.type === "Card") {
				state.user.paymentMethods = state.user.paymentMethods.concat(new CardPaymentMethod(action.data));
			} else if (action.data.type === "Sepa") {
				state.user.paymentMethods = state.user.paymentMethods.concat(new SepaPaymentMethod(action.data));
			}
			state.isLoading = state.isLoading.filter((c) => c !== Loadings.ADDING_PAYMENTMETHOD);
			return { ...state };

		case ActionTypes.ADD_PAYMENTMETHOD_REQUEST:
			if (!state.isLoading.includes(Loadings.ADDING_PAYMENTMETHOD)) {
				state.isLoading = state.isLoading.concat(Loadings.ADDING_PAYMENTMETHOD);
			}
			return { ...state };

		case ActionTypes.REMOVE_PAYMENTMETHOD_REQUEST:
			if (!state.isLoading.includes(Loadings.DELETING_PAYMENTMETHOD)) {
				state.isLoading = state.isLoading.concat(Loadings.DELETING_PAYMENTMETHOD);
			}
			return { ...state };

		case ActionTypes.REMOVE_PAYMENTMETHOD_SUCCESS:
			state.user.paymentMethods = state.user.paymentMethods.filter((p) => p.id !== action.paymentMethod.id);
			state.isLoading = state.isLoading.filter((c) => c !== Loadings.DELETING_PAYMENTMETHOD);
			return { ...state };

		case ActionTypes.GET_SETUPINTENT_REQUEST:
			if (!state.isLoading.includes(Loadings.GETTING_SETUPINTENT)) {
				state.isLoading = state.isLoading.concat(Loadings.GETTING_SETUPINTENT);
			}
			return { ...state };
		case ActionTypes.GET_SETUPINTENT_SUCCESS:
			state.stripeClientSecret = action.data;
			state.isLoading = state.isLoading.filter((c) => c !== Loadings.GETTING_SETUPINTENT);
			return { ...state };

		case ActionTypes.FETCH_INVOICES_REQUEST:
			if (!state.isLoading.includes(Loadings.FETCH_INVOICES)) {
				state.isLoading = state.isLoading.concat(Loadings.FETCH_INVOICES);
			}
			return { ...state };
		case ActionTypes.FETCH_INVOICES_SUCCESS:
			if (!R.isNil(action.data) && action.data.length > 0) {
				state.invoices = action.data.map((invoice) => new Invoice(invoice));
			}
			state.isLoading = state.isLoading.filter((c) => c !== Loadings.FETCH_INVOICES);
			return { ...state };
		case ActionTypes.FETCH_INVOICES_FAILURE:
			state.isLoading = state.isLoading.filter((c) => c !== Loadings.FETCH_INVOICES);
			toast.error(Text.invoicesErrorMessage, toastConf);
			return { ...state };

		case ActionTypes.UPDATE_USER_SECURITY_REQUEST:
			if (!state.isLoading.includes(Loadings.UPDATE_SECURITY)) {
				state.isLoading = state.isLoading.concat(Loadings.UPDATE_SECURITY);
			}
			return { ...state };
		case ActionTypes.UPDATE_USER_SECURITY_SUCCESS:
			if (!R.isNil(action.user.newPhoneNumber)) {
				state.user.phoneNumber = action.user.newPhoneNumber;
				sessionStorage.removeItem("access_token");
				window.location = "/auth/signin" + (window.location.search !== "" ? window.location.search : "");
			}
			if (!R.isNil(action.user.newEmail)) {
				state.user.email = action.user.newEmail;
			}
			state.isLoading = state.isLoading.filter((c) => c !== Loadings.UPDATE_SECURITY);
			toast.success(Text.updateSecuritySuccess, toastConf);
			return { ...state };
		case ActionTypes.UPDATE_USER_SECURITY_FAILURE:
			state.isLoading = state.isLoading.filter((c) => c !== Loadings.UPDATE_SECURITY);
			toast.error(Text.udpateSecurityFailed, toastConf);
			return { ...state };

		case ActionTypes.PROCESS_PAYMENT_REQUEST:
			if (!state.isLoading.includes(Loadings.PROCESSING_PAYMENT)) {
				state.isLoading = state.isLoading.concat(Loadings.PROCESSING_PAYMENT);
			}
			return { ...state };

		case ActionTypes.PROCESS_PAYMENT_FAILURE:
			state.isLoading = state.isLoading.filter((c) => c !== Loadings.PROCESSING_PAYMENT);
			toast.error(Text.udpateSecurityFailed, toastConf);
			return { ...state };

		case ActionTypes.PROCESS_PAYMENT_SUCCESS:
			state.isLoading = state.isLoading.filter((c) => c !== Loadings.PROCESSING_PAYMENT);
			return { ...state };

		case AuthActionTypes.VERIFY_OTP_REQUEST:
			if (!state.isLoading.includes(Loadings.VALIDATING_OTP)) {
				state.isLoading.push(Loadings.VALIDATING_OTP);
			}
			return { ...state };

		case AuthActionTypes.VERIFY_OTP_SUCCESS:
			state.isLoading = state.isLoading.filter((s) => s !== Loadings.VALIDATING_OTP);
			if (!R.isNil(action.phoneNumber)) {
				state.user = { ...state.user, phoneNumber: action.phoneNumber };
			}
			return { ...state };

		case AuthActionTypes.VERIFY_OTP_FAILURE:
			state.isLoading = state.isLoading.filter((s) => s !== Loadings.VALIDATING_OTP);
			return { ...state };

		case AuthActionTypes.SEND_OTP_CODE_REQUEST:
			if (!state.isLoading.includes(Loadings.SENDING_OTP)) {
				state.isLoading.push(Loadings.SENDING_OTP);
			}
			return { ...state };

		case AuthActionTypes.SEND_OTP_CODE_SUCCESS:
			state.isLoading = state.isLoading.filter((s) => s !== Loadings.SENDING_OTP);
			return { ...state };

		case AuthActionTypes.SEND_OTP_CODE_FAILURE:
			state.isLoading = state.isLoading.filter((s) => s !== Loadings.SENDING_OTP);
			return { ...state };

		case AuthActionTypes.SET_NEWPASSWORD_REQUEST:
			if (!state.isLoading.includes(Loadings.UPDATE_SECURITY)) {
				state.isLoading.push(Loadings.UPDATE_SECURITY);
			}
			return { ...state };

		case AuthActionTypes.SET_NEWPASSWORD_SUCCESS:
			state.isLoading = state.isLoading.filter((s) => s !== Loadings.UPDATE_SECURITY);
			return { ...state };

		case AuthActionTypes.SET_NEWPASSWORD_FAILURE:
			state.isLoading = state.isLoading.filter((s) => s !== Loadings.UPDATE_SECURITY);
			return { ...state };

		case ActionTypesFacilita.FETCH_USER_SERVICES_DATA_REQUEST:
			if (!state.isLoading.includes(LoadingsFacilita.FETCHING_USER_SERVICES_DATA)) {
				state.isLoading.push(LoadingsFacilita.FETCHING_USER_SERVICES_DATA);
			}
			return { ...state };

		case ActionTypesFacilita.FETCH_USER_SERVICES_DATA_SUCCESS:
			state.isLoading = state.isLoading.filter((s) => s !== LoadingsFacilita.FETCHING_USER_SERVICES_DATA);
			state.serviceDatas = action.data;
			return { ...state };

		case ActionTypesFacilita.FETCH_USER_SERVICES_DATA_FAILURE:
			state.isLoading = state.isLoading.filter((s) => s !== LoadingsFacilita.FETCHING_USER_SERVICES_DATA);
			return { ...state };

		case ActionTypes.FETCH_PARTNER_CUSTOMIZATION_REQUEST:
			if (!state.isLoading.includes(Loadings.FETCH_PARTNER_CUSTOMIZATION)) {
				state.isLoading.push(Loadings.FETCH_PARTNER_CUSTOMIZATION);
			}
			return { ...state };

		case ActionTypes.FETCH_PARTNER_CUSTOMIZATION_DEFAULT_SUCCESS:
			state.partnerCustomization = { ...state.partnerCustomization, isLoaded: true };
			return { ...state };

		case ActionTypes.FETCH_PARTNER_CUSTOMIZATION_SUCCESS:
			state.isLoading = state.isLoading.filter((s) => s !== Loadings.FETCH_PARTNER_CUSTOMIZATION);
			state.partnerCustomization = action.data;
			state.partnerCustomization = { ...state.partnerCustomization, isLoaded: true };

			return { ...state };

		case ActionTypes.FETCH_PARTNER_CUSTOMIZATION_FAILURE:
			state.isLoading = state.isLoading.filter((s) => s !== Loadings.FETCH_PARTNER_CUSTOMIZATION);
			return { ...state };

		case ActionTypes.FETCH_LIFEEVENTS_REQUEST:
			state.events = [...state.events];
			return { ...state };

		case ActionTypes.FETCH_LIFEEVENTS_SUCCESS:
			state.isLoading = state.isLoading.filter((s) => s !== Loadings.FETCH_LIFEEVENTS);
			state.events = action.data;
			state.events = [...state.events];

			return { ...state };

		case ActionTypes.FETCH_LIFEEVENTS_FAILURE:
			state.isLoading = state.isLoading.filter((s) => s !== Loadings.FETCH_LIFEEVENTS);
			return { ...state };

		default:
			return state;
	}
};
export default UserReducer;
